import Body from 'commons/card/Body';
import { default as Card } from 'commons/card/CollapsableCard';
import Header from 'commons/card/Header';
import LoadingCard from 'commons/card/LoadingCard';
import GenericGrid from 'pages/tables/GenericGrid';
import PropTypes from 'prop-types';
import React, { Fragment, useState } from 'react';
import CreateDateModal from './modals/CreateDateModal';
import { useAddAnnonceVigueurMutation, useGetAnnoncesVigueurQuery, useRemoveAnnonceVigueurMutation, useUpdateAnnoncesVigueurMutation } from '../../../redux/api/cache';

export default function MessageDate(props) {
  const [createModal, setCreateModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(undefined);
  const { data: annonces, isLoading } = useGetAnnoncesVigueurQuery({ ann_seq: props.data.ann_seq });
  const [addAnnonceVigueur] = useAddAnnonceVigueurMutation();
  const [updateAnnonceVigueur] = useUpdateAnnoncesVigueurMutation();
  const [removeAnnonceVigueur] = useRemoveAnnonceVigueurMutation();

  const fileClicked = (rowData) => {
    setSelectedRow(rowData);
    setCreateModal(true);
  };

  const remove = async () => {
    let result = await removeAnnonceVigueur(selectedRow.rid).unwrap();
    if (result.success) {
      let newData = JSON.parse(JSON.stringify(annonces));
      newData.data.splice(
        newData.data.findIndex((item) => item.rid === selectedRow.rid),
        1
      );
    }
  };

  const create = async (values) => {
    if (selectedRow === undefined) {
      await addAnnonceVigueur(values);
    } else {
      let result = await updateAnnonceVigueur(values).unwrap();
      if (result.success) {
        let newData = JSON.parse(JSON.stringify(annonces));
        newData.data.splice(
          newData.data.findIndex((item) => item.rid === selectedRow.rid),
          1
        );
        newData.data.push(result.data[0]);
      }
    }
  };

  return (
    <Fragment>
      {createModal && (
        <CreateDateModal
          message={props.data}
          selectedRow={selectedRow}
          create={create}
          remove={remove}
          toggleDialog={() => {
            setCreateModal(!createModal);
          }}
        />
      )}
      {isLoading && <LoadingCard title="Chargement Dates..." />}
      {!isLoading && annonces && (
        <Card
          expanded={annonces?.data?.length > 0 || isLoading}
          key={'card vigueur'}
        >
          <Header title={`Dates en vigueur`}></Header>
          <Body>
            <GenericGrid
              autoSize={true}
              showCreateBtn={true}
              onCreateClick={() => {
                setSelectedRow(undefined);
                setCreateModal(true);
              }}
              rowClicked={fileClicked}
              definition={annonces.meta.definition}
              data={annonces.data}
              txtBtn="Ajouter une date"
            ></GenericGrid>
          </Body>
        </Card>
      )}
    </Fragment>
  );
}

MessageDate.propTypes = {
  data: PropTypes.shape({
    ann_seq: PropTypes.any,
  }),
  path: PropTypes.string,
};
